// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__aqgQf","content":"styles_content__egr5W","checkbox":"styles_checkbox__2_IPe","checkboxLabel":"styles_checkboxLabel__3i0f7"};